<template>
  <div>
    <div>
      <div v-if="boolLogin" class="Rectangle-3">
        <div class="Rectangle-2">
          <div
            style="
              text-align: left;
              width: 30%;
              vertical-align: middle;
              display: inline-block;
            "
          >
            <img
              class="Rectangle-1-img"
              style="margin-top: 10px; margin-left: 70px"
              src="./assets/logo.png"
            />
          </div>
          <div
            style="
              text-align: right;
              width: 68%;
              vertical-align: middle;
              display: inline-block;
            "
          >
            <div
              style="
                display: inline-block;
                color: #fff;
                font-size: 18px;
                margin-top: 20px;
              "
            ></div>
          </div>
        </div>
      </div>

      <div>
        <el-col
          v-if="boolLogin"
          class="Rectangle-4-nav"
          :span="3"
          v-bind:style="{ height: +(windowHeight - 100) + 'px', width: '10%' }"
        >
          <el-menu
            default-active="1"
            class="el-menu-vertical-demo"
            :router="true"
          >
            <el-submenu index="1">
              <template slot="title">
                <img
                  style="width: 20px; height: 20px; margin-right: 20px"
                  src="./assets/staff-icon.png"
                />
                <span>用户管理</span>
              </template>
              <el-menu-item index="userList">用户列表</el-menu-item>
              <el-menu-item index="member">会员管理</el-menu-item>
            </el-submenu>
            <el-submenu index="2">
              <template slot="title">
                <img
                  style="width: 20px; height: 20px; margin-right: 20px"
                  src="./assets/order-icon.png"
                />
                <span>订单管理</span>
              </template>
              <el-menu-item index="orderList">订单列表</el-menu-item>
              <el-menu-item index="carList">货车管理</el-menu-item>
              <el-menu-item index="driverList">司机管理</el-menu-item>
            </el-submenu>
            <el-submenu index="3">
              <template slot="title">
                <img
                  style="width: 20px; height: 20px; margin-right: 20px"
                  src="./assets/product-icon.png"
                />
                <span>产品管理</span>
              </template>
              <el-menu-item index="categoriesList">分类修改</el-menu-item>
              <el-menu-item index="productList">产品列表</el-menu-item>
              <el-menu-item index="shopList">店铺列表</el-menu-item>
            </el-submenu>

            <el-submenu index="4">
              <template slot="title">
                <img
                  style="width: 20px; height: 20px; margin-right: 20px"
                  src="./assets/other-icon.png"
                />
                <span>其他操作</span>
              </template>
              <el-menu-item index="banDate">禁送日期</el-menu-item>
              <el-menu-item index="banPhone">封禁电话</el-menu-item>
              <el-menu-item index="areaList">地区修改</el-menu-item>
              <el-menu-item index="specialCate">特殊标签</el-menu-item>
              <el-menu-item index="imgModify">首页图片</el-menu-item>
              <el-menu-item index="adModify">广告图片</el-menu-item>
              <el-menu-item index="orderRestriction">单量限制</el-menu-item>
              <el-menu-item index="orderTotal">下单金额限制</el-menu-item>
              <!--修改-->
              <el-menu-item index="textModify">文字修改</el-menu-item>
            </el-submenu>

               <el-submenu index="5">
              <template slot="title">
                <img
                  style="width: 20px; height: 20px; margin-right: 20px"
                  src="./assets/market-icon.png"
                />
                <span>市场营销</span>
              </template>
              <el-menu-item index="couponList">优惠券</el-menu-item>
              <el-menu-item index="lottery">抽奖列表</el-menu-item>
            </el-submenu>

            <el-submenu index="6">
              <template slot="title">
                <img
                  style="width: 20px; height: 20px; margin-right: 20px"
                  src="./assets/setting.png"
                />
                <span>账号设定</span>
              </template>
              <!-- <el-menu-item index="myProfile">账户信息</el-menu-item> -->
              <el-menu-item @click="onLogOut()">退出登入</el-menu-item>
            </el-submenu>
          </el-menu>
        </el-col>
      </div>
      <div
        class="Rectangle-4"
        v-bind:style="{ height: +(windowHeight - 100) + 'px' }"
      >
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "app",

  data() {
    return {
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
      boolLogin: false,
    };
  },
  mounted() {
    this.onCheckloginRole();
  },
  methods: {
    onCheckloginRole() {
      // if (temp == undefined || temp != "b60afdc1f3657130c165d32743603a59") {
      //   this.$router.push("/login");
      //   this.boolLogin = false;
      //   return;
      // } else {
      //   this.$router.push("/userList");
      //   this.boolLogin = true;
      // }
      var temp = localStorage.getItem("auth");

      this.axios.post(this.$urlGlobal + "adminCheck", {
        auth: temp
      }).then((res) => {
        if (res.data.code == -1) {
          this.$router.push("/login");
          this.boolLogin = false;
        } else {
          this.$router.push("/userList");
          this.boolLogin = true;
        }
      });
    },
    onLogOut() {
      localStorage.removeItem("auth");
      window.location.reload();
    },
  },
};
</script>

<style >
/* .el-menu-item.is-active{
  color:#1bb24b;
} */
.Rectangle-1 {
  width: 100%;
  height: 100%;
}
.Rectangle-3 {
  width: 100%;
  height: 100%;
  background-color: #f2f2f2;
}
.Rectangle-1-img {
  width: 80px;
  height: 70px;
}
.Rectangle-2 {
  width: 100%;
  height: 100px;
  background-color: #1bb24b;
  border-radius: 0px;
  text-align: left;
}
.Rectangle-4 {
  width: 100%;
  background-color: #f2f2f2;
}
.Rectangle-4-nav {
  z-index: 20;
  background-color: #fff;
}

.Rectangle-5 {
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.16);
  border-radius: 19px;
  border-radius: 19px;
  width: 99%;
}

.comm-block {
  background: #ffffff;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.16);
  border-radius: 10px;
  border-radius: 10px;
}

.comm-text {
  font-family: PingFangSC-Light;
  color: #4d4d4d;
  letter-spacing: 0.71px;
}

.shadow-zIndex-5 {
  z-index: 5;
  width: 100%;
  height: 100%;
  opacity: 0.5;
  position: absolute;
  background-color: black;
  top: 0;
  left: 0;
}

/* .el-menu-item.is-active{
  color:#1bb24b;
} */
</style>>